export function convertRemToPixels(rem: number): number {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize || '1');
}

export function convertBytesToGb(bytes: number): number {
  return bytes / 8 / 1024 / 1024 / 1024;
}
